export const registerIntroBannerId: string = 'taxfree';
